import React from 'react';

import styles from './OffersPopUp.module.css';
import { NavLink } from 'react-router-dom';

const NotClient = () => {

    return (
        <>
            <h1 className={styles.title}>Veuillez vous connecter ❌</h1>
            <p className={styles.subtitle}>
                Pour profiter de ce coupon, créez d’abord votre compte Dealygo — c’est rapide et ça vous donne accès à toutes nos offres !
            </p>
            <NavLink to='/login'><button className={styles.btn}>Connexion</button></NavLink>
        </>
    );
};

export default NotClient;